import { ONBOARDING_CHECK_STATUSES } from '../verifyOnboardingData'
import styles from './OnboardingVerification.module.scss'

const statusStyles = {
  [ONBOARDING_CHECK_STATUSES.ok]: styles.ok,
  [ONBOARDING_CHECK_STATUSES.warning]: styles.warning,
  [ONBOARDING_CHECK_STATUSES.unknown]: styles.unknown
}

const OnboardingVerificationTrigger = ({ verification, onClick }) => {
  if (!verification || verification.checks.length === 0) {
    return null
  }

  const numberOfWarnings = verification.checks.filter(
    check => check.status === ONBOARDING_CHECK_STATUSES.warning
  ).length

  return (
    <button className={styles.trigger} type="button" onClick={onClick}>
      <span className={styles.triggerDots}>
        {verification.checks.map(check => (
          <span
            key={check.key}
            className={[styles.dot, statusStyles[check.status]].join(' ')}
          />
        ))}
      </span>
      <span className={styles.triggerText}>
        <span className={styles.triggerTitle}>Verify onboarding status</span>
        <span className={styles.triggerSummary}>
          {numberOfWarnings === 0
            ? 'Uploaded data looks consistent'
            : numberOfWarnings === 1
            ? '1 check needs attention'
            : `${numberOfWarnings} checks need attention`}
        </span>
      </span>
      <span className={styles.triggerArrow}>›</span>
    </button>
  )
}

export default OnboardingVerificationTrigger
